// extracted by mini-css-extract-plugin
export default {"dialog":"FullScreenDialog_dialog__YcPw2","toolbar":"FullScreenDialog_toolbar__BY7W9"};